/* eslint-disable */
import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { Switch, Redirect, BrowserRouter as Router } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import "./App.css";
// Import scss
import "./assets/scss/theme.scss";
import Cookies from "universal-cookie";
import axios from "axios";
import { checkAuth } from "./store/actions";
import { userLogged } from "./helpers/backend_helper";
import toastr from "toastr";
const cookies = new Cookies();
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_APIURL;

// import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
// fakeBackend()

const App = (props) => {
  function getLayout() {
    let layoutCls = VerticalLayout;

    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  // useEffect(() => {
  //   userLogged().then((res) => {
  //     // toastr.error(res.messa);

  //     if (res.status >= 400) {
  //       toastr.error(res.message);
  //       localStorage.removeItem("authUser");
  //       // window.location.reload();
  //     }
  //   });
  // }, []);

  useEffect(() => {
    if (cookies.get("rememberMe") === "false") {
      localStorage.removeItem("authUser");
      <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
    }
  }, []);

  const Layout = getLayout();
  return (
    <React.Fragment>
      <Router>
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware path={route.path} layout={NonAuthLayout} component={route.component} key={idx} isAuthProtected={false} />
          ))}

          {userRoutes.map((route, idx) => (
            <Authmiddleware path={route.path} layout={Layout} component={route.component} key={idx} isAuthProtected={true} exact />
          ))}
        </Switch>
      </Router>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
